import type { Product } from "schemas/generated/product";

import * as React from "react";

import twMerge from "@replo/design-system/utils/twMerge";
import { STATUS_CONFIGS } from "@v2/features/products/utils";

type StatusIconProps = {
  status: Product["status"];
};

export const StatusIcon: React.FC<StatusIconProps> = ({ status }) => {
  const config = STATUS_CONFIGS[status as keyof typeof STATUS_CONFIGS];
  const iconClass = config?.iconClass ?? "bg-component";
  return <div className={twMerge("w-2 h-2 rounded-full", iconClass)} />;
};
